import { trackLandingActivation, trackLandingTourRequested } from '../../utils/landingExperimentAnalytics';
import { Prisma, showings } from '@prisma/client';
import axiosInstance from '../api';

const showingsService = {
  find: async () => {
    const res = await axiosInstance.get('/showings');
    return res.data;
  },
  get: async (id: string) => {
    const res = await axiosInstance.get<showings>(`/showings/${id}`);
    return res.data;
  },
  post: async (
    data: Prisma.showingsCreateWithoutUserInput,
    isTour = false,
    notify = true
  ) => {
    const res = await axiosInstance.post('/showings', data, {
      params: {
        isTour,
        notify,
      },
    });
    if (isTour) {
      trackLandingActivation('tour_requested');
      if (typeof res.data?.id === 'string') trackLandingTourRequested(res.data.id);
    }
    return res.data;
  },
  patch: async (
    id: string,
    data: Prisma.showingsUpdateInput & {
      agentBooks?: boolean;
      cancellationReason?: string;
    }
  ) => {
    const res = await axiosInstance.patch(`/showings/${id}`, data);
    return res.data;
  },
  put: async (id: string, data: Prisma.showingsUpdateInput) => {
    const res = await axiosInstance.put(`/showings/${id}`, data);
    return res.data;
  },
};

export default showingsService;
